import Logger from '../../functions/logging';
import {
	SET_TECH_CHECK_SPEAKER_TEST_ANSWER,
	SET_TECH_CHECK_PLAYBACK_TEST_ANSWER,
	SET_TECH_CHECK_CONNECTION_RESULT,
	SET_TECH_CHECK_CONNECTION_SPEED_RESULT,
	SET_TECH_CHECK_FINISHED_STATUS,
} from '../actions/constants';
import TEST_STATUS from '../../constants/status';

const INITIAL_STATE = {
	speakerAnswer: null,
	playbackAnswer: null,
	speaker: TEST_STATUS.pending,
	player: TEST_STATUS.pending,
	connection: TEST_STATUS.pending,
	connectionSpeed: TEST_STATUS.pending,
	techCheckFinished: false
};

export default function (state = INITIAL_STATE, action) {
	Logger.log('techCheck.js REDUCER()', action.type);

	switch (action.type) {
		case SET_TECH_CHECK_SPEAKER_TEST_ANSWER: {
			const isCorrect = action.answer && action.answer.isCorrect;
			return {
				...state,
				speakerAnswer: action.answer,
				speaker: isCorrect ? TEST_STATUS.success : TEST_STATUS.fail,
			};
		}
		case SET_TECH_CHECK_PLAYBACK_TEST_ANSWER: {
			const isCorrect = action.answer && action.answer.isCorrect;
			return {
				...state,
				playbackAnswer: action.answer,
				player: isCorrect ? TEST_STATUS.success : TEST_STATUS.fail,
			};
		}
		case SET_TECH_CHECK_CONNECTION_RESULT:
			return { ...state, connection: action.result };
		case SET_TECH_CHECK_CONNECTION_SPEED_RESULT:
			return { ...state, connectionSpeed: action.result };
		case SET_TECH_CHECK_FINISHED_STATUS:
			return { ...state, techCheckFinished: action.status };
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/reducers/techCheck.js